import { Service } from "typedi";
import { v4 as uuidv4 } from "uuid";
import { AnnouncementData } from "../../../shared/ChannelProtocol";

type Listener = (announcement: AnnouncementData | null) => void;

/** v1: a single active announcement at a time. */
@Service()
export class AnnouncementState {
    private current: AnnouncementData | null = null;
    private readonly listeners = new Set<Listener>();

    get(): AnnouncementData | null {
        return this.current;
    }

    announce(message: string): AnnouncementData {
        const data: AnnouncementData = { id: uuidv4(), message };
        this.current = data;
        this.notify();
        return data;
    }

    dismiss(id: string): void {
        if (this.current?.id !== id) return;
        this.current = null;
        this.notify();
    }

    onChange(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    private notify(): void {
        this.listeners.forEach((l) => {
            try { l(this.current); } catch (err) { console.error("[announcement-state] listener error", err); }
        });
    }
}
